import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F9A81054-5651-47DE-9507-E0743AE78E77
 * name moon-first-quarter
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moon-first-quarter.svg
 * tags
 * - Weather 
 */
export const MoonFirstQuarterIcon = createSvgIcon(<><path d="M12 2V22A10 10 0 0 0 12 2Z" /></>, 'MoonFirstQuarterIcon');
export default MoonFirstQuarterIcon